/* eslint eqeqeq: 0*/
/* eslint no-mixed-operators: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import { Field, reduxForm } from 'redux-form';
import Checkbox from 'material-ui/Checkbox';
import styled from 'styled-components';
import { BODY_TEXT_COLOR, NEGATIVE_COLOR } from '../../config/colors'
import { TrashIcon } from '../../icons';
import './style.css';

const $ = require("jquery");
const required = value => value ? undefined : 'Required';
const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;
const minLength5 = minLength(5);

const CONTAINER_HEIGHT = '100%';
import {isDelivery} from '../../selectors/configSelectors';

const styles = {
    trashIconWrap: {"position":"absolute","right":"0","margin":"-3px 23px 0 0"},
    floatingText: {color: NEGATIVE_COLOR},
    textField: {fontSize: '16px', fontWeight:'400', color: BODY_TEXT_COLOR },
    underlineStyle: {borderColor: BODY_TEXT_COLOR},
    checkbox: {   },
    checkBoxLabel: { fontWeight: 400, fontSize: '16px', color: BODY_TEXT_COLOR },
    button: { width: '120px', fontWeight: 700 },
    editForm: {margin: '0'},
    trashIcon: {height:'25px', width:'25px', cursor: 'pointer'},
    trashIconColor: "red",
    labelStyle: { fontWeight: 700 }
}
class EditAddressForm extends Component {
    floatingLabelStyle = {color: ['#',this.props.secondaryColor].join('')};
    floatingFocusLabelStyle = {color: ['#',this.props.secondaryColor].join('')};
    underlineFocusStyle = { borderColor: ['#',this.props.secondaryColor].join('')};
    fields = {
        'street': null,
        'city': null,
        'zip': null,
        'note': null,
    }
    state = {
        isInputAddressActive: false,
        inputNameFocused: null,
        mainContainerHeight: CONTAINER_HEIGHT,
    }

    handleInputEnterPress = (e,  inputName, touched, error) => {
        if ((e.key === 'Enter' || e.key == '13') && error === undefined) {
            if (inputName === 'street') {
                e.preventDefault();
                this.onInputBlur('street');
                setTimeout(()=>{
                    this.fields['city'].focus();
                },250);
            } else if (inputName === 'city') {
                e.preventDefault();
                this.onInputBlur('city');
                setTimeout(()=>{
                    this.fields['zip'].focus();
                },250);
            } else if (inputName === 'zip') {
                e.preventDefault();
                this.onInputBlur('zip');
                setTimeout(()=>{
                    this.fields['note'].focus();
                },250);
                // this.props.handleSubmit();
            }  else if (inputName === 'note') {
                e.preventDefault();
                this.onInputBlur('note');
            }
        }
    }

    onInputFocus = (inputName) => {

    }

    onInputBlur = (inputName) => {

    }

   renderStreetField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={(input) => {this.fields['street'] = input;}}
            onKeyPress={(e) => this.handleInputEnterPress(e, 'street', touched, error)}
            onFocus={() => this.onInputFocus('street')}
            onBlur={()=>this.onInputBlur('street')}
            floatingLabelText={<span style={styles.floatingText}>Street</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingFocusLabelStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
            disabled
        />
    )
    renderAptField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            type="apt"
            ref={(input) => {this.fields['apt'] = input;}}
            floatingLabelText={<span style={styles.floatingText}>Apt. #</span>}
            maxLength="10"
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingFocusLabelStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            {...input}
            {...custom}
        />
    )
   renderCityField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            type="city"
            ref={(input) => {this.fields['city'] = input;}}
            onKeyPress={(e) => this.handleInputEnterPress(e, 'city', touched, error)}
            onFocus={() => this.onInputFocus('city')}
            onBlur={()=>this.onInputBlur('city')}
            floatingLabelText={<span style={styles.floatingText}>City</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingFocusLabelStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
            disabled
        />
    )
    renderZipField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
                onInput={(e)=>{
                e.target.value = Math.max(0, parseInt(e.target.value, 10) ).toString().slice(0,5)
            }}
            ref={(input) => {this.fields['zip'] = input;}}
            type="number"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'zip', touched, error)}
            onFocus={()=>this.onInputFocus('zip')}
            onBlur={()=>this.onInputBlur('zip')}
            floatingLabelText={<span style={styles.floatingText}>Zip Code</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingFocusLabelStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
            disabled
        />
    )
    renderNoteField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={(input) => {this.fields['note'] = input;}}
            type="text"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'note', touched, error)}
            onFocus={()=>this.onInputFocus('note')}
            onBlur={()=>this.onInputBlur('note')}
            floatingLabelText={<span style={styles.floatingText}>Delivery Notes</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingFocusLabelStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            // multiLine={true}
            textareaStyle={{marginTop:0}}
            {...input}
            {...custom}
        />
    )

    renderCheckBox = (props) => (
        <Checkbox
          checked={props.input.value ? true : false}
          onCheck={props.input.onChange}
          iconStyle={{marginLeft:'15px', fill: '#'+this.props.secondaryColor}}
          labelStyle={styles.checkBoxLabel}
          label="Set as Primary Address"
          labelPosition="left"
          style={styles.checkbox}
        />
    )

  getFieldDisplayVal = (fieldName) => {
    return (!this.state.isInputAddressActive || this.state.isInputAddressActive && this.state.inputNameFocused === fieldName) ? 'block' : 'none';
  }

  onRemove = () => {
      this.props.onCloseRequest();
      this.props.onRemoveAddress();
  }
  render() {
    const { handleSubmit } = this.props;
    const { isInputAddressActive, inputNameFocused } = this.state;
    return (
        <form name="editaddress" onSubmit={handleSubmit} style={styles.editForm}>

           {!this.state.isInputAddressActive &&
            <div>
                <div onClick={this.onRemove} style={styles.trashIconWrap}>
                    <TrashIcon style={styles.trashIcon} color={styles.trashIconColor} />
                </div>
                <HeaderTitle>Edit Address</HeaderTitle>
                <HorLine />
            </div>
           }

            <FormWrapper style={{height: this.state.mainContainerHeight}}>
                {(!isInputAddressActive || inputNameFocused === 'street') &&
                    <div>
                        <Field
                            onFocus={() => this.onInputFocus('street')}
                            onBlur={()=>this.onInputBlur('street')}
                            name="street"
                            validate={[ required ]}
                            component={this.renderStreetField} />
                    </div>
                }
                {(!isInputAddressActive || inputNameFocused === 'apt') &&
                    <div>
                        <Field
                            name="apt"
                            component={this.renderAptField} />
                    </div>
                }
               {(!isInputAddressActive || inputNameFocused === 'city') &&
                    <div>
                        <Field
                            onFocus={() => this.onInputFocus('city')}
                            onBlur={()=>this.onInputBlur('city')}
                            name="city"
                            validate={[ required ]}
                            component={this.renderCityField} />
                    </div>
               }

                {(!isInputAddressActive || inputNameFocused === 'zip') &&
                    <div>
                        <Field
                            onFocus={() => this.onInputFocus('zip')}
                            onBlur={()=>this.onInputBlur('zip')}
                            name="zip"
                            validate={[ required, minLength5 ]}
                            component={this.renderZipField} />
                    </div>
                }

                {!isInputAddressActive && this.props.deliveryAvailable &&
                    <CheckBoxWrapper>
                        <Field
                            name="isdefault"
                            component={this.renderCheckBox} />
                    </CheckBoxWrapper>
                }

                {(!isInputAddressActive || inputNameFocused === 'note') &&
                    <div>
                        <Field
                            onFocus={() => this.onInputFocus('note')}
                            name="comment"
                            component={this.renderNoteField} />
                    </div>
                }

                {this.props.addressError && (
                  <div className="error">{this.props.addressError}</div>
                )}


            </FormWrapper>

            {!this.state.isInputAddressActive &&
                <ButtonsWrapperDiv>
                    <LeftDiv><ButtonDiv onClick={this.props.onCloseRequest}>Cancel</ButtonDiv></LeftDiv>
                    <RightDiv><ButtonDiv onClick={handleSubmit} color={`#` + this.props.secondaryColor}>Save</ButtonDiv></RightDiv>
                </ButtonsWrapperDiv>
            }

        </form>
    );
  }
}

EditAddressForm = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'EditAddressForm',
})(EditAddressForm)

const mapStateToProps = (state) => {
  return {
    isPhone: state.config.isPhone,
    is_iPhone: state.config.is_iPhone,
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    deliveryAvailable: isDelivery(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAddressForm);

const HeaderTitle = styled.div `
  text-align: center;
  margin-top: 18px;
  font-size: 21px;
  font-weight: 800;
  font-family: 'Futura-Bold';
  color: ${BODY_TEXT_COLOR};
`
const CheckBoxWrapper = styled.div `
  width: 256px;
  margin-top: 14px;
`

const HorLine = styled.hr `
    display: block;
    height: 2px;
    border: 0;
    border-top: 2px solid #f4f4f4;
    margin: 1em 0 0;
    padding: 0;
`;

const FormWrapper = styled.div `
    display: flex;
    color: #515151;
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 0 0 30px 0;
    height: 100%;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
`;



const ButtonsWrapperDiv = styled.div `
  height: 50px;
  width: 100%;
  border-top: 1px solid #E6E6E7;
`;

const LeftDiv = styled.div `
    float:left;
    width: 50%;
    background-color: #fff;
    height: 100%;
    border-right: 1px solid #E6E6E7;
    box-sizing: border-box;
`;

const RightDiv = styled.div `
    float: right;
    background-color: #fff;
    height: 100%;
    width: 50%;
`;

const ButtonDiv = styled.div `
    cursor: pointer;
    display: flex;
    font-weight: 400;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding: 15px;
    color: ${props => {
      if (props.disabled) {
        return "#E6E6E7"
      } else if (props.color) {
        return props.color;
      } else {
        return '#616161';
      }
    }};
`;



// WEBPACK FOOTER //
// ./src/components/EditAddressForm/EditAddressForm.jsx